import apis from '@apis/index';
import { Button } from '@chakra-ui/react';
import React, { ErrorInfo, ReactNode } from 'react';

type Props = {
  children: ReactNode;
  fallback?: ReactNode;
};

interface State {
  hasError: boolean;
}

const skippableErrors = /Googlebot|AdsBot/;

class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  handleGoHome = () => {
    location.href = '/';
  };

  async sendError(data: any) {
    if (!skippableErrors.test(navigator.userAgent)) {
      await apis.log.createErrorLog(data);
    }
  }

  async componentDidCatch(error: Error, errorInfo: ErrorInfo) {
      localStorage.removeItem('cart');
      await this.sendError({
        // ✅ Error 객체 수동 직렬화
        error: {
          name: error.name,
          message: error.message,
          stack: error.stack,
        },
        errorInfo: {
          componentStack: errorInfo.componentStack,
        },
        route: location?.href,
        // 추가 컨텍스트
        userAgent: navigator.userAgent,
        timestamp: new Date().toISOString(),
      });
  }

  render(): ReactNode {
    const { hasError } = this.state;

    if (!hasError) {
      return this.props.children;
    }

    return (
      <div
        style={{
          display: 'flex',
          width: '100vw',
          height: '100vh',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#123',
          color: 'white',
        }}
      >
        <div
          // className="bg-white p-6 rounded-lg shadow-lg text-center space-y-4 max-w-md"
          style={{ marginBottom: '42px' }}
        >
          <h1
            // className="text-2xl font-bold text-red-500"
            style={{
              fontSize: '22px',
              textAlign: 'center',
              marginBottom: '24px',
            }}
          >
            Something went wrong
          </h1>
          <p
            // className="text-gray-700"
            style={{ padding: '0 18px', marginBottom: '14px' }}
          >
            We encountered an unexpected error. Please try refreshing the page,
            or click below to return to the homepage.
          </p>
          <div
            style={{ padding: '0 18px', marginBottom: '14px', width: '100%' }}
          >
            <Button onClick={this.handleGoHome} w="100%" textColor="#123">
              Go to Home
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export { ErrorBoundary };
